export default __webpack_public_path__ + "static/media/3132 knife block B side.8d6bb9df.png";